(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["finisterre-template"]) return;
  try {
    

jQuery(function ($) {
	$('.product-info-icon').on('click', function(){

		$(this).siblings('.product-info-card').toggle();
	
		if ( $(this).hasClass('is-active') ) {
		} else {
			$(this).addClass('is-active');
			$(this).parent('.product-info-container').addClass('is-active');
			$('.product-info-icon').not(this).removeClass('is-active');
			$('.product-info-icon').not(this).parent('.product-info-container').removeClass('is-active');
			$('.product-info-icon').not(this).siblings('.product-info-card').hide();
		}

		$('.product-info-card').on('click', function(){
			$(this).parent('.product-info-container').removeClass('is-active');
			$(this).siblings('.product-info-icon').removeClass('is-active');
			$(this).hide();
		});

	
	});


	
	var heroVideo = $(".hero-video");
	var mediaVideo = $(".hero-video").get(0);
	var playButton = $('.play-button');
	heroVideo.hide();

	if ($(window).width() >= 1025) {
	$('.hero').click(function () {

	    if (mediaVideo.paused) {
			heroVideo.show();
       		mediaVideo.play();
			playButton.hide();
	    } else {
			heroVideo.hide();
        	mediaVideo.pause();
			playButton.show();		
		}
	});
	} else {
		playButton.hide();
	}

	var gridVideo = $(".grid-video");
	var mainVideo = $(".grid-video").get(0);
	var gridplayButton = $('.grid-play-button');
	gridVideo.hide();

	if ($(window).width() >= 1025) {
	$('.grid-image.img-1').click(function () {

	    if (mainVideo.paused) {
			gridVideo.show();
       		mainVideo.play();
			gridplayButton.hide();
	    } else {
			gridVideo.hide();
        	mainVideo.pause();
			gridplayButton.show();		
		}
	});
	} else {
		gridplayButton.hide();
	}

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-carousel"]) return;
  try {
    
jQuery(function ($) {
$(document).ready(function () {
  
if ($(window).width() < 1300) {
  $("#mobDel").remove();
}
  if ($('.siema-products')[0]) {
const slider = new Siema({
selector: '.siema-products',
duration: 200,
easing: 'ease-out',
perPage: {
700: 2, // 1 items for viewport wider than 700px
1024: 3, // 3 items for viewport wider than 1250px
1920: 4,
2560: 5
},
startIndex: 0,
draggable: true,
multipleDrag: false,
threshold: 20,
loop: false,
rtl: false,
onInit: () => {
},
onChange: () => {
},
});
let prev = document.querySelector('.product-slider-navigation .prev');
let next = document.querySelector('.product-slider-navigation .next');

prev.addEventListener('click', () => slider.prev());
next.addEventListener('click', () => slider.next());
  }
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"]) return;
  try {
    
$('span.tongue').on('click', function() {
$('.boot-container div').removeClass('is-active');
$('.boot-container span').removeClass('is-active');
$('div.tongue').addClass('is-active');
$(this).addClass('is-active');
})
$('span.toe').on('click', function() {
$('.boot-container div').removeClass('is-active');
$('.boot-container span').removeClass('is-active');
$('div.toe').addClass('is-active');
$(this).addClass('is-active');
})
$('span.sole').on('click', function() {
$('.boot-container div').removeClass('is-active');
$('.boot-container span').removeClass('is-active');
$('div.sole').addClass('is-active');
$(this).addClass('is-active');
})
$('span.arch').on('click', function() {
$('.boot-container div').removeClass('is-active');
$('.boot-container span').removeClass('is-active');
$('div.arch').addClass('is-active');
$(this).addClass('is-active');
})
$('span.heel').on('click', function() {
$('.boot-container div').removeClass('is-active');
$('.boot-container span').removeClass('is-active');
$('div.heel').addClass('is-active');
$(this).addClass('is-active');
})
$('span.calf').on('click', function() {
$('.boot-container div').removeClass('is-active');
$('.boot-container span').removeClass('is-active');
$('div.calf').addClass('is-active');
$(this).addClass('is-active');
})

  } catch(e) { console.error(e); }
})();
})();
